import {enviroments} from '../enviroments/enviroment';
import axios from 'axios';

export const sendEmail = (userContact) => {
    axios.post(`${enviroments.apiUrl}/conversions?api_key=${enviroments.apiKey}`, {
        'event_type': 'CONVERSION',
        'event_family': 'CDP',
        'payload': {
            'conversion_identifier': 'Probies',
            'email': userContact.email,
            'name': userContact.name,
            'mobile_phone': userContact.phone,
            'company_name': userContact.company,
            'cf_company_employees': userContact.employees,
            'cf_company_segment': userContact.segment,
        }
    })
} 

export const sendEmailAlunos = (userContact) => {
    axios.post(`${enviroments.apiUrl}/conversions?api_key=${enviroments.apiKey}`, {
        'event_type': 'CONVERSION',
        'event_family': 'CDP',
        'payload': {
            'conversion_identifier': 'Probies',
            'email': userContact.email,
            'name': userContact.name,
            'mobile_phone': userContact.phone,
            'cf_students_interestarea': userContact.interestArea,
        }
    })
}